// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/page/deal/Deal.css
// module id = 1435
// module chunks = 0